import React from "react";
import ProductCategory from "../../lib/Pages/ProductCategory";

export default function ProductCategoryPage() {
  return <ProductCategory />;
}
